import { render, staticRenderFns } from "./CreateShipment.vue?vue&type=template&id=14846556"
import script from "./CreateShipment.vue?vue&type=script&lang=ts"
export * from "./CreateShipment.vue?vue&type=script&lang=ts"
import style0 from "./CreateShipment.vue?vue&type=style&index=0&id=14846556&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports